import { render, staticRenderFns } from "./home-type3-content.vue?vue&type=template&id=f6144694&scoped=true"
import script from "./home-type3-content.vue?vue&type=script&lang=js"
export * from "./home-type3-content.vue?vue&type=script&lang=js"
import style0 from "./home-type3-content.vue?vue&type=style&index=0&id=f6144694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1__yidcnbbritke6h73lk2rhpn7vi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6144694",
  null
  
)

export default component.exports